import { Pipe, PipeTransform } from '@angular/core';
import {deviceTypeCodeMap} from '../shareModel';

@Pipe({
  standalone: false,
  name: 'deviceTypeCode'
})
export class DeviceTypeCodePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (deviceTypeCodeMap.hasOwnProperty(value)) {
      return deviceTypeCodeMap[value];
    }
    return null;
  }

}
